import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessageWithClass, Image, Link } from '../commonComponents';
import content from 'Content/content.json';
import FooterConfig, { isEmptySocial } from '../../configuration/Footer';
import { language, LANG_JP, LANG_VI, LANG_AZ } from 'Root/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import './footer.scss';
import { ClickLayer } from '../../ga4';
// Todo: Move all constants and process.env to Utils.js
// Todo: Refactor JSX into subcomponents

const footerText = content['data']['footerText'][language];
const warningText = content['data']['warningText'][language];
const footerTextAdditional = content['data']['footerTextAdditional'][language];

const footerLinks = {
  'about': process.env.REACT_APP_ACUVUE,
  'contact': process.env.REACT_APP_CONTACT_US,
  'privacy': process.env.REACT_APP_PRIVACY_POLICY,
  'legal': process.env.REACT_APP_LEGAL_NOTICE,
  'patient_guide': process.env.REACT_APP_PATIENT_GUIDE
};

const socialLinks = {
  'facebook': process.env.REACT_APP_FACEBOOK ? process.env.REACT_APP_FACEBOOK : null,
  'twitter': process.env.REACT_APP_TWITTER ? process.env.REACT_APP_TWITTER : null,
  'youtube': process.env.REACT_APP_YOUTUBE ? process.env.REACT_APP_YOUTUBE : null,
  'instagram': process.env.REACT_APP_INSTAGRAM ? process.env.REACT_APP_INSTAGRAM : null,
  'kakao': process.env.REACT_APP_KAKAO ? process.env.REACT_APP_KAKAO : null,
  'weibo': process.env.REACT_APP_WEIBO ? process.env.REACT_APP_WEIBO : null,
  'wechat': process.env.REACT_APP_WECHAT ? process.env.REACT_APP_WECHAT : null,
  'zhihu': process.env.REACT_APP_ZHIHU ? process.env.REACT_APP_ZHIHU : null,
};

const socialIcons = {
  'facebook': require('../../assets/imgs/new/social_icons/facebook.png'),
  'twitter': require('../../assets/imgs/new/social_icons/twitter.png'),
  'youtube': require('../../assets/imgs/new/social_icons/youtube.png'),
  'instagram': require('../../assets/imgs/new/social_icons/instagram.png')
}
const EmptySocial = Object.values(socialLinks).every(link => link === null || link === '');

const Footer = () => {
  const {
    links: { parent_link, social_link },
  } = FooterConfig();

  const filteredLinks = (links) => links.filter((link) => link.href);
  const { REACT_APP_BUILD_DATE } = process.env;
  if(language === LANG_AZ) {
    return (
      <footer className="footer">
      <div className="footer-row footer-top">
        <div className="container">
          { language !== 'ja' &&
            <div className="text-small links-label">
              about
            </div>
          }
          <ul className="list-reset footer-links">
            <li>
              <a className="text-small" href={footerLinks.about} target="_blank">
                <FormattedMessageWithClass id="footer.acuvue" defaultMessage="About Acuvue® Define™" />
                <FontAwesomeIcon icon={faAngleRight} />
              </a>
            </li>
            <li>
              <a className="text-small" href={footerLinks.contact} target="_blank">
                <FormattedMessageWithClass id="footer.contact" defaultMessage="Contact Us" />
                <FontAwesomeIcon icon={faAngleRight} />
              </a>
            </li>
            <li>
              <a className="text-small" href={footerLinks.privacy} target="_blank">
                <FormattedMessageWithClass id="footer.privacy" defaultMessage="Privacy Policy" />
                <FontAwesomeIcon icon={faAngleRight} />
              </a>
            </li>
            <li>
              <a className="text-small" href={footerLinks.legal} target="_blank">
                <FormattedMessageWithClass id="footer.legal" defaultMessage="Legal Notice" />
                <FontAwesomeIcon icon={faAngleRight} />
              </a>
            </li>
            { footerLinks.patient_guide &&
              <li>
                <a className="text-small" href={footerLinks.patient_guide} target="_blank">
                  <span>Patient Instruction Guide</span>
                  <FontAwesomeIcon icon={faAngleRight} />
                </a>
              </li>
            }
          </ul>
        </div>
      </div>
      { !EmptySocial &&
        <div className="footer-row footer-middle">
          <div className="container">
            <div className="social-links">
              { socialLinks.facebook &&
                <div className="social-item social-item--facebook">
                  <a className="social-item-link" href={socialLinks.facebook}  target="_blank">
                    <img className="icon" src={socialIcons.facebook} />
                  </a>
                </div>
              }
              { socialLinks.twitter &&
                <div className="social-item social-item--twitter">
                  <a className="social-item-link" href={socialLinks.twitter}  target="_blank">
                    <img className="icon" src={socialIcons.twitter} />
                  </a>
                </div>
              }
              { socialLinks.youtube &&
                <div className="social-item social-item--youtube">
                  <a className="social-item-link" href={socialLinks.youtube}  target="_blank">
                    <img className="icon" src={socialIcons.youtube} />
                  </a>
                </div>
              }
              { socialLinks.instagram &&
                <div className="social-item social-item--instagram">
                  <a className="social-item-link" href={socialLinks.instagram}  target="_blank">
                    <img className="icon" src={socialIcons.instagram} />
                  </a>
                </div>
              }
              { socialLinks.kakao &&
                <div className="social-item social-item--kakao">
                  <a className="social-item-link" href="https://pf.kakao.com/_xhxoNyI" target="_blank">
                    <KakaoIcon />
                  </a>
                </div>
              }
              { socialLinks.weibo &&
                <div className="social-item social-item--weibo">
                  <a className="social-item-link" href={socialLinks.weibo}  target="_blank">
                    <FontAwesomeIcon icon={['fab', 'weibo']} size="2x" />
                  </a>
                </div>
              }
              { socialLinks.wechat &&
                <div className="social-item social-item--wechat">
                  <a className="social-item-link">
                    <FontAwesomeIcon icon={['fab', 'weixin']} size="2x" />
                    <span class="qr-code">
                      <img className="img-responsive" src={require(`../../assets/imgs/new/${socialLinks.wechat}`)} />
                    </span>
                  </a>
                </div>
              }
              { socialLinks.zhihu &&
                <div className="social-item social-item--zhihu">
                  <a className="social-item-link" href={socialLinks.zhihu}  target="_blank">
                    <FontAwesomeIcon icon={['fab', 'zhihu']} size="2x" />
                  </a>
                </div>
              }
            </div>
          </div>
        </div>
      }
      <div className="footer-row footer-bottom">
        <div className="container footer-text text-small md-text-center">
          {
            footerText.map((item, index) => {
              return (
                <p
                  key={index}
                  className="m-0"
                  dangerouslySetInnerHTML={{__html: item}}
                />
              )
            })
          }
        </div>
      </div>
    </footer>
    );
  }
  else {
    return (
      <footer className="footer--wrapper">
        {language === 'twq' && (
          <div className="footer--row footer--warning">
            {warningText.map((warningItem, warningIndex) => (
              <p
                key={warningIndex}
                dangerouslySetInnerHTML={{ __html: warningItem }}
              />
            ))}
          </div>
        )}
        {language !== LANG_JP && (
          <div className="footer--row footer--top">
            {language !== LANG_JP && (
              <ul className="lists footer--disclosure">
                {/*
                    @TODO
                    Make this list as a component and compatible enough
                    to render other languages Remove Dependency of Formatted message
                  */}
                {process.env.REACT_APP_REGION === 'EMEA' ? ('') : (
                  <li className="lists--item" data-layer-menu_item="lists--item">
                    <FormattedMessageWithClass
                      id="footer.label"
                      defaultMessage="About"
                      className="link"
                    />
                  </li>
                )}
              </ul>
            )}
  
            <ul className="lists footer--navigation">
              {filteredLinks(parent_link).map(
                ({ className, href, target, id, defaultMessage }, index) => (
                  <li key={index} className="lists--item" data-layer-menu_item="lists--item">
                    <Link
                      className={className}
                      href={href}
                      target={target}
                      id={id}
                      defaultMessage={defaultMessage}
                    />
                  </li>
                )
              )}
            </ul>
          </div>
        )}
        {language !== LANG_JP && language !== LANG_VI &&
          // (process.env.REACT_APP_REGION !== 'EMEA' && language !== 'ru' ? ('') : (
            <ul
              className={`lists footer--row footer--mid footer--socials${
                isEmptySocial ? ' hide' : ''
              }`}
            >
              {filteredLinks(social_link).map(
                (
                  {
                    parentClassName,
                    className,
                    imgClassName,
                    icon,
                    href,
                    target,
                  },
                  index
                ) => (
                  <li className={parentClassName} key={index}>
                    <Link className={className} href={href} target={target}>
                      <Image className={imgClassName} src={icon} onClick={ () => {ClickLayer('socailsLink')}}/>
                    </Link>
                  </li>
                )
              )}
            </ul>
          //))
          }
  
        <div className="footer--row footer--bottom">
          {footerText.map((item, index) => {
            return <p key={index} dangerouslySetInnerHTML={{ __html: item }} />;
          })}       
          {process.env.REACT_APP_REGION === 'EMEA' && (
            <span >
            <FormattedMessageWithClass
              id="LastUpdate"
              defaultMessage="Last Update:"            
            /> {process.env.REACT_APP_BUILD_DATE}
            </span>
          )}       
  
          {language === 'arabia_en' || language === 'ru'?
            footerTextAdditional.map((item, index) => (
              <p key={index} dangerouslySetInnerHTML={{ __html: item }} />
            ))
            :''
          }
        </div>
      </footer>
    );
  }
};

export default withRouter(Footer);
